<template>
  <Popper
    :delay-on-mouse-over="delay"
    :options="{ placement: placement }"
    :trigger="trigger">
    <div class="popper_ziggu">
      <slot name="tip"/>
    </div>
    <slot slot="reference" name="content" />
  </Popper>
</template>

<script>
import Popper from 'vue-popperjs';

export default {
  name: 'VPopper',
  components: { Popper },
  props: {
    placement: { type: String, default: 'top' },
    delay: { type: Number, default: 300 },
    trigger: { type: String, default: 'hover', required: false },
  },
};
</script>
